import React, { Fragment, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchTooltipData } from '@actions/tooltips-actions';
import ActivityLogTooltip from '@components/activity-logs/tooltips';
import { Icon } from '@mui';
import TaskStatusChip from '@shared/workflow/task-status-chip';
import './tooltip.scss';

const TaskActivityTooltip = ({ children, id, text }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.tooltips.task_activity[id]);
  const error = useSelector(state => state.tooltips.error.task_activity?.[id]);
  const taskStatuses = useSelector(state => state.dataTypes.task_status);

  const handleFetch = useCallback(() => {
    dispatch(fetchTooltipData('task_activity', null, id));
  }, [dispatch, id]);

  const handleLinkClick = useCallback(() => {
    if (data) {
      window.open(`/cycle/${data.cycle_id}/task/${data.task}/activity/${id}/detect`, '_blank');
    }
  }, [data, id]);

  const renderTitle = useCallback(() => (
    <Fragment>
      <div styleName="body-title-icon">
        <Icon aria-hidden="true">assignment</Icon>
      </div>
      <div styleName="body-title-text">
        {data?.task_type_name}
      </div>
    </Fragment>
  ), [data]);

  const renderContent = useCallback(() => {
    const statuses = Object.values(taskStatuses || {});
    const taskStatus = statuses.find(status => status.name === data?.status_name);
    return (
      <div styleName="body-content">
        <div styleName="body-row body-item">
          {data?.task_name}&nbsp;({data?.agency_name})
        </div>
        <div styleName="body-row">
          <TaskStatusChip taskStatus={taskStatus} />
        </div>
      </div>
    );
  }, [data, taskStatuses]);

  return (
    <ActivityLogTooltip
      data={data}
      error={error}
      onFetch={handleFetch}
      renderTitle={renderTitle}
      renderContent={renderContent}
      linkLabel="VIEW TASK ACTIVITY"
      onLinkClick={handleLinkClick}
      dataType="task_activity"
    >
      {children || text}
    </ActivityLogTooltip>
  );
};

TaskActivityTooltip.propTypes = {
  children: PropTypes.node,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string
};

export default TaskActivityTooltip;
